import Header from "../components/Header";
import HeroSection from "../components/Homesections/Heroslider";
import AboutSection from "../components/Homesections/aboutsection";
import AboutDoctor from "../components/Homesections/aboutdoctor";
import AreasOfExpertise from "../components/Homesections/areaofexperties";
// import CDATASection from "../components/Homesections/cta";
import Slider from "../components/Homesections/slider";
import ObsGynae from "../components/Homesections/ObsGynae";
import Footer from "../components/Footer";
import FemaleInfertility from "../components/Homesections/FemaleInfertility";
import HealthPrioritySection from "../components/Homesections/HealthPrioritySection";
import WhyTrustUs from "../components/Homesections/lastsection";
import CTASection from "../components/CTA";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Dr Vibha Clinic | IVF & Fertility Specialist</title>
        <meta
          name="description"
          content="Welcome to Dr Vibha’s Clinic, a trusted IVF and fertility center offering advanced infertility treatments, personalized care, and high success rates to help you achieve parenthood."
        />
        <meta
          name="keywords"
          content="IVF clinic, fertility center, infertility treatment, IVF specialist, fertility doctor, IVF treatment India, Dr Vibha Clinic"
        />
        <meta name="author" content="Dr Vibha’s Clinic" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Dr Vibha’s Clinic | IVF & Fertility Specialist"
        />
        <meta
          property="og:description"
          content="Leading fertility clinic providing advanced IVF treatments and compassionate care to help couples achieve their dream of parenthood."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      {<Header />}
      {<Slider />}
      {<HeroSection />}
      {<AboutSection />}
      {<AboutDoctor />}
      {<AreasOfExpertise />}
      {<ObsGynae />}
      {<HealthPrioritySection />}
      {<FemaleInfertility />}
      {<WhyTrustUs />}
      <CTASection
        title="Take One Step Closer To"
        highlight="Parenthood"
        description="Every journey to becoming a parent is unique. At Dr vibha Clinic, we combine care, expertise, and technology to give you the best chance of success."
        buttonText="BOOK  APPOINTMENT"
        buttonLink="/contact-us"
      />
      {<Footer />}
    </>
  );
};

export default Home;
